import { useDispatch } from 'react-redux';
import { showAlert } from '../redux/alertSlice';
import { SEVERITIES } from '../data/constants';
import { logHandledError } from '../utils/errorLogger';

export const useToaster = () => {
  const dispatch = useDispatch();

  return (message: string, severity: typeof SEVERITIES[keyof typeof SEVERITIES]) => {
    // Failures the caller detected itself (e.g. an API that resolved false) throw
    // nothing, so this toast is the only signal they happened — log it too.
    if (severity === SEVERITIES.ERROR) {
      logHandledError(message, window.location.href);
    }
    dispatch(
      showAlert({
        message: message,
        severity: severity,
      })
    );
  };
};
